module.exports = __webpack_public_path__ + "static/bottom-a3ef824cae026f57ff109bf222485f3d.png";